export default __webpack_public_path__ + "static/social_media_success-516fbc7d51c92c25a4afa7b71264b6d1.webp";